<template>
    <div>
        <div class="col-md-3 col-xs-12">
            <va-small-box
              class="info-box box-green"
              icon="ion-bag "
              :title="totalDisbursementAmt"
              description="Total Disbursement Amount"
              @more-click="clickToTotalDisbursment"
              moreText="More info">
            </va-small-box>
        </div>
        <div class="col-md-3 col-xs-12">
            <va-small-box
              class="info-box box-red"
              icon="ion-bag "
              :title="totalOutstandingAmt"
              description="Total Outstanding Amount"
              @more-click="clickToTotalOutstanding"
              moreText="More info">
            </va-small-box>
        </div>
    </div>
</template>
<script>
import VASmallBox from '../widgets/VASmallBox.vue'
export default {
  props: ['message'],
  data () {
    return {
      totalOutstanding: 0,
      totalDisbursement: 0
    }
  },
  computed: {
    totalDisbursementAmt () {
      if (this.message[1]) {
        this.totalDisbursement = parseFloat(this.message[1].totalDisbursment + 0).toFixed(2)
      }
      return this.totalDisbursement
    },
    totalOutstandingAmt () {
      // var settlementDiff = 0
      if (this.message[2]) {
        this.totalOutstanding = parseFloat(this.message[2].totalOutstanding + 0).toFixed(2)
      }
      // if (this.message[28]) {
      //   settlementDiff = this.message[28].sattlement.dueAmt - this.message[28].sattlement.deuPaidAmt
      //   // settlementDiff = this.message[28].sattlement.dueAmt
      // }
      // return this.totalOutstanding - settlementDiff
      return this.totalOutstanding
    }
  },
  methods: {
    clickToTotalDisbursment () {
      this.$router.push({name: 'loanSummary'})
    },
    clickToTotalOutstanding () {
      this.$router.push({name: 'emiCollection'})
    }
  },
  components: {
    'va-small-box': VASmallBox
  }
}
</script>
<style>
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .blueColor {
    color: rgb(12, 156, 55);
  }
  .box-red {
    background-color:#ec1c22;
    color: #fff;
  }
  .box-green {
    background-color: #0e8c0e;
    color: #fff;
  }
  /* .iconColor {
    color: rgb(12, 156, 55);
  } */
  /* .small-box > .small-box-footer {
  background: rgb(12, 156, 55);
} */
</style>



// WEBPACK FOOTER //
// totaloutstanding.vue?65aa01a9